"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgFilePdf48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h48v48H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M35.25 18.5H27v-8.25m8.25 8.353V38.75H12v-28.5h15.016l8.234 8.353h0ZM22.808 29.1c1.244-3.46 1.895-7.204 0-6.844-1.894.36-.529 3.808.888 6.124 1.416 2.317 4.107 4.912 5.253 3.404s-1.87-2.357-5.474-2.138c-3.605.218-6.168 2.56-4.99 3.442 1.177.881 3.08-.529 4.323-3.988Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgFilePdf48;
